module.exports = __webpack_public_path__ + "img/jifen3.c023f525.png";